//#region [IMPORT]

// === CONSTANTS ===
import { FAILURE_CODE, SUCCESS_CODE } from "constants/general";

//#endregion

//#region [METHOD] === EXTERNAL

//-----------------------------------------------------------------
function validate(content, validation_info) {
  //-----------------------------------------------------------------
  const result = {
    content: content,
    message: '',
    status: SUCCESS_CODE,
  };

  validateInvalidTypes( result, validation_info );

  if( result.status === FAILURE_CODE ) return result;
  
  const {acceptableValues} = validation_info;
  validateAcceptedTypes( result, acceptableValues )
  
  if( result.status === FAILURE_CODE ) return result;
  
  ensureContentHasPrefix( result );

  return result;
};

//-----------------------------------------------------------------
function validateInvalidTypes( result, validation_info ) {
  //-----------------------------------------------------------------
  if( !validation_info.isFirstPage ) return;

  const is_following = result.content.startsWith('F') || result.content.startsWith('B');

  if( !is_following ) return;

  result.message = 'First page cannot be changed to Following Page or a Blank page!';
  result.status = FAILURE_CODE;
}

//-----------------------------------------------------------------
function validateAcceptedTypes(result, acceptable_values) {
  //-----------------------------------------------------------------
  try {
    const is_valid = acceptable_values.includes( result.content );
    if(is_valid) return;

    result.message = 'Value is not a recognized Page Type. Please select a value from the list.';
  } catch (error) {
    result.message = 'An error has occurred.';
    console.warn( error );
  }

  result.status = FAILURE_CODE;
}

//-----------------------------------------------------------------
function ensureContentHasPrefix( result ) {
  //-----------------------------------------------------------------
  if (
    !result.content.includes('D') &&
    !result.content.includes('F') &&
    !result.content.includes('B')
  ) {
    result.content = 'D' + result.content;
  }
}

//#endregion

export { validate };